export const SELECTION_STATE = {
  SELECTED: `selected`,
  RESOLVED: `resolved`,
} as const;

export type SelectionState =
  (typeof SELECTION_STATE)[keyof typeof SELECTION_STATE];
